'use strict'

class Toast{
    constructor(element, status = 'success', title = '', light = false){
        this.main = element;
        this._icon = this.main.querySelector('.toast__icon');
        this._title = this.main.querySelector('.toast__title');
        
        this._resolveFunction = null;
        
        this._isShow = false;

        this.setStatus(status, title, light);
        
    }

    setStatus(status, title, light){
        this._title.innerHTML = title;
        if(light) this.main.classList.add('toast--light');
        switch(status){
            case 'warning':
                this.main.classList.add('toast--warning');
                this._icon.src = `${IMG_PATH}icons/toast/warning.svg`;
                this._icon.width = 24;

            break;
            case 'success':
                this.main.classList.add('toast--success');
                this._icon.src = `${IMG_PATH}icons/toast/success.svg`;
                this._icon.width = 24;
            break;
            case 'error':
            default:
                this.main.classList.add('toast--error');
                this._icon.src = `${IMG_PATH}icons/toast/error.svg`;
                this._icon.width = 24;
            break;        
        }
    }
    
    show(){
        this._isShow = true;
        return new Promise((resolve, reject)=>{
            this.main.classList.add('toast--show');
            this._resolveFunction = resolve;
        })
    }

    hide(){
        if(this._isShow){
            this.main.classList.remove('toast--show');
            this._isShow = false;
            this._resolveFunction(false);
        }        
    }

    get isShow(){
        return this._isShow;
    }

}


export default Toast;